<script>
import NavBar from "@/components/NavBar";
import SideBarMakeup from "@/components/SideBarMakeup";
import FooterBar from "@/components/FooterBar";

export default {
  components: {
    NavBar,
    SideBarMakeup,
    FooterBar
  }
}
</script>

<style scoped src="@/assets/css/inbox.css">
</style>

<template>
  <div >
    <nav-bar />

    <section class="main-content columns is-fullheight">
			
        <div class="column is-2 sidebar-container"  >
          <SideBarMakeup />
        </div>

    
        <div class=" column is-10">
          <div class="section">
            <router-view/>
          
          
          </div>
        </div>
      
		</section>

    

    <footer-bar />

  </div>

</template>



